import React from "react";
import { Cta } from "../cta";

export default function FooterNoteAndCTA({ footnote, ctaText, ctaLink }) {
  return (
    <>
      <div className="mt-16 mb-6 text-center text-base font-normal text-gray-500">
        {footnote}
      </div>
      <Cta ctaText={ctaText} ctaLink={ctaLink} />
    </>
  );
}
